module.exports = __webpack_public_path__ + "img/social3.67baf8bd.png";